var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0ZM15.099 11.5189C15.099 12.8265 14.1147 13.8728 12.5343 13.8728H12.5054C10.9837 13.8728 10 12.8265 10 11.5189C10 10.1837 11.0137 9.16667 12.5642 9.16667C14.1147 9.16667 15.0696 10.1837 15.099 11.5189ZM14.8005 15.7316V29.3496H10.268V15.7316H14.8005ZM31.146 29.3497L31.1462 21.5415C31.1462 17.3586 28.9102 15.4118 25.9276 15.4118C23.5212 15.4118 22.4438 16.7336 21.8422 17.6608V15.7319H17.3092C17.369 17.0098 17.3092 29.35 17.3092 29.35H21.8422V21.7446C21.8422 21.3376 21.8716 20.9315 21.9915 20.6401C22.3191 19.8271 23.0649 18.9852 24.3171 18.9852C25.9578 18.9852 26.6137 20.234 26.6137 22.064V29.3497H31.146Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.6c317e2d6775e9ba02f6248b96872e86.svg";
export { ForwardRef as ReactComponent };